<template>
  <component :is="fieldLayoutComponent" id="associate-partnership-field" ref="fieldLayout" :content="content">
    <h2>{{ i18n.t('activerecord.models.partnership.one') }}</h2>
    <association-toggle v-if="hasSinglePartnershipOption" ref="partnershipToggle"
                        :label="labelForSingleOption" :initial-value="singleOptionSelected"
                        :associated-entity-id="valueForOption(partnershipOptions[0])"
                        @changed="updateFieldValue" />
    <selector-input v-else ref="partnershipSelector" :field="field"
                    :options="partnershipOptionsWithBlank"
                    :initial-value="value" :validation-errors="validationErrors"
                    @changed="updateFieldValue" />
  </component>
</template>

<script>
import AssociationToggle from './campaign-association-field'
import SelectorInput from '@/components/inputs/selector-input'
import FieldLayout from './field-layout'
import FieldMixin from './field-mixin'
import { mapState } from 'vuex'

export default {
  components: { AssociationToggle, FieldLayout, SelectorInput },

  mixins: [ FieldMixin ],

  props: {
    fieldLayoutComponent: {
      type: Object,
      required: false,
      default() { return FieldLayout }
    },

    labelForSingleOption: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState(['partnershipOptions']),

    hasSinglePartnershipOption() {
      return this.partnershipOptions.length === 1
    },

    partnershipOptionsWithBlank() {
      return [['', null]].concat(this.partnershipOptions)
    },

    singleOptionSelected() {
      return this.value !== null
    }
  },

  methods: {
    focus() {
      if (this.hasSinglePartnershipOption) {
        this.$refs.partnershipToggle.focus()
      } else {
        this.$refs.partnershipSelector.focus()
      }
    },

    scrollIntoView() {
      // We must override the scrollIntoView method from FieldMixin because there isn't a single field element defined
      this.$refs.fieldLayout.scrollIntoView()
    },

    valueForOption(option) {
      return option[1]
    }
  }
}
</script>


<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

::v-deep(select) {
  height: 58px;

  @include breakpoints.screen-mobile-only {
    height: 50px;
  }

}
</style>
